// extracted by mini-css-extract-plugin
export default {"modal":"ShareModal_modal__vVHK3","button":"ShareModal_button__F+qh6","delete":"ShareModal_delete__u6szb"};